// const apMenu = [
//   {
//     System: 'AP',
//     isActive: false,
//     menu: [
//       // { is_header: true, title: 'إدارة المدفوعات', isActive: true },
//       { is_header: true, title: '', isActive: true },

//       {
//         path: '/AP/HomePage',
//         icon: 'fas fa-home',
//         title: 'HomePage',
//         isActive: true
//       },

//       { is_header: true, title: 'Settings', isActive: true },

//       {
//         path: '/AP/Suppliers',
//         icon: 'fas fa-handshake',
//         title: 'Suppliers',
//         isActive: true
//       },
//       {
//         path: '/AP/TypesOfExpenses',
//         icon: 'fas fa-coins',
//         title: 'TypesOfExpenses',
//         isActive: true
//       },
//       {
//         path: '/AP/PaymentTerms',
//         icon: 'fas fa-calendar-check',
//         title: 'PaymentTerms',
//         isActive: true
//       },
//       {
//         path: '/AP/Currencies',
//         icon: 'fas fa-globe',
//         title: 'Currencies',
//         isActive: true
//       },

//       { is_header: true, title: 'Operations', isActive: true },

//       {
//         path: '/AP/ApInvoices',
//         icon: 'fas fa-cash-register',
//         title: 'PaymentInvoices',
//         isActive: true
//       },
//       {
//         path: '/AP/CreateAccountApInvoices',
//         icon: 'fas fa-share-square',
//         title: 'PostPaymentInvoices',
//         isActive: true
//       },

//       {
//         path: '/AP/ApPayments',
//         icon: 'fas fa-wallet',
//         title: 'PaymentVouchers',
//         isActive: true
//       },
//       {
//         path: '/AP/CreateAccountApPayments',
//         icon: 'fas fa-share-square',
//         title: 'PostPaymentVouchers',
//         isActive: true
//       },

//       {
//         path: '/AP/ApExpense',
//         icon: 'fas fa-hand-holding-usd',
//         title: 'Expenses',
//         isActive: true
//       },

//       {
//         path: '/AP/AccountingPeriod',
//         title: 'AccountingPeriod',
//         icon: 'fas fa-calendar-alt',
//         isActive: true
//       },

//       { is_header: true, title: 'Reports', isActive: true },
//       {
//         path: '/AP/ApReports',
//         icon: 'fas fa-chart-line',
//         title: 'Reports',
//         isActive: true
//       },
//       {
//         path: '/AP/ApDashboards',
//         icon: 'fas fa-th-large',
//         title: 'Dashboard',
//         isActive: true
//       }
//     ]
//   }
// ];

// export default apMenu;

const apMenu = [
  {
    System: 'AP',
    isActive: false,
    menu: [
      { is_header: true, title: '', isActive: true },

      {
        path: '/AP/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true,
        // ✨ إضافة دالة الاستيراد للتحميل المسبق
        importer: () => import('@pages/Finance/Ap/Main/ApDashboard')
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/AP/Suppliers',
        icon: 'fas fa-handshake',
        title: 'Suppliers',
        isActive: true,
        importer: () => import('@pages/PUR/Settings/Suppliers/Index')
      },
      {
        path: '/AP/TypesOfExpenses',
        icon: 'fas fa-coins',
        title: 'TypesOfExpenses',
        isActive: true,
        importer: () => import('@pages/Finance/Settings/TypesOfExpenses/ExpenseCategory/Index')
      },
      {
        path: '/AP/PaymentTerms',
        icon: 'fas fa-calendar-check',
        title: 'PaymentTerms',
        isActive: true,
        importer: () => import('@pages/Finance/Settings/PaymentTerms/Index')
      },
      {
        path: '/AP/Currencies',
        icon: 'fas fa-globe',
        title: 'Currencies',
        isActive: true,
        importer: () => import('@pages/Finance/Settings/Currencies/Index')
      },

      { is_header: true, title: 'Operations', isActive: true },

      {
        path: '/AP/ApInvoices',
        icon: 'fas fa-cash-register',
        title: 'PaymentInvoices',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApInvoices/Index')
      },
      {
        path: '/AP/CreateAccountApInvoices',
        icon: 'fas fa-share-square',
        title: 'PostPaymentInvoices',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApInvoices/CreateAccount/ListApInvoices')
      },

      {
        path: '/AP/ApPayments',
        icon: 'fas fa-wallet',
        title: 'PaymentVouchers',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApPayments/Index')
      },
      {
        path: '/AP/CreateAccountApPayments',
        icon: 'fas fa-share-square',
        title: 'PostPaymentVouchers',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApPayments/CreateAccount/ListApPayments')
      },

      {
        path: '/AP/ApExpense',
        icon: 'fas fa-hand-holding-usd',
        title: 'Expenses',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApExpense/Index')
      },

      {
        path: '/AP/AccountingPeriod',
        title: 'AccountingPeriod',
        icon: 'fas fa-calendar-alt',
        isActive: true,
        importer: () => import('@pages/Finance/Settings/AccountingPeriod/Index')
      },

      { is_header: true, title: 'Reports', isActive: true },
      
      {
        path: '/AP/ApReports',
        icon: 'fas fa-chart-line',
        title: 'Reports',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApReports/ApReports')
      },
      {
        path: '/AP/ApDashboards',
        icon: 'fas fa-th-large',
        title: 'Dashboard',
        isActive: true,
        importer: () => import('@pages/Finance/Ap/ApDashboards/ApDashboards')
      }
    ]
  }
];

export default apMenu;